/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {useCallback, useEffect, useState} from 'react';

import {getMonth, getYear} from 'date-fns';
import i18n from 'i18next';
import {ReactDatePickerProps} from 'react-datepicker';
import {useTranslation} from 'react-i18next';

import 'react-datepicker/dist/react-datepicker.css';
import {ReactComponent as LeftArrowIcon} from 'assets/svg/arrow-left.svg';

import {yearsOptions} from 'utils/select';

import {Icon} from '../Icon';
import {Select, SelectOption} from '../Select';

import {DatePickerInput} from './input';
import {DatePickerArrow, DatePickerHead, InnerDatePicker} from './styled';

export type DatePickerProps = {
    disabled?: boolean;
    placeholder?: string;
    label?: string;
    value?: any;
    selected?: Date;
    onChange?: (selected: (Date | null)[]) => void;
};

const formatDate = (date: Date) => {
    const day = date
        .getDate()
        .toString()
        .padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

export const DatePickerRanged = ({
    selected,
    value: sadsd,
    onChange: onChangeProp,
    placeholder,
    label,
    disabled,
}: DatePickerProps) => {
    const [dataRange, setDataRange] = useState<Date | [Date | null, Date | null] | null>(
        sadsd ?? [null, null],
    );

    const [start, end] = dataRange as [Date | null, Date | null];

    function handleChange(x: Date | [Date | null, Date | null] | null) {
        setDataRange(x);
        const [changdStart, changedEnd] = x as [Date | null, Date | null];
        if (onChangeProp) {
            onChangeProp([changdStart, changedEnd]);
        }

        return [changdStart, changedEnd];
    }

    const dates = useCallback(
        () => ({
            from: start ? formatDate(start) : '',
            to: end ? formatDate(end) : '',
        }),
        [dataRange],
    );
    const {from, to} = dates();
    const {t} = useTranslation();
    const options = yearsOptions();
    const monthsKeys = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];
    const months = monthsKeys.map((key, i) => ({
        label: t('dictionaries.months.' + key),
        value: i,
    }));

    const renderCustomHeader = ({
        date,
        decreaseMonth,
        increaseMonth,
        changeMonth,
        changeYear,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }: Parameters<NonNullable<ReactDatePickerProps['renderCustomHeader']>>[0]) => (
        <DatePickerHead>
            <DatePickerArrow
                onClick={decreaseMonth}
                type="button"
                disabled={prevMonthButtonDisabled}
            >
                <Icon source={LeftArrowIcon} height={14} width={14} />
            </DatePickerArrow>
            <Select
                options={months}
                value={months.find((o) => o.value === getMonth(date))}
                onChange={(v: SelectOption<number>) => {
                    v.value && changeMonth(v.value);
                }}
            />
            <Select
                options={options}
                value={options.find((o) => o.value === getYear(date))}
                onChange={(v: SelectOption<number>) => v.value && changeYear(v.value)}
            />
            <DatePickerArrow
                onClick={() => {
                    increaseMonth();
                }}
                disabled={nextMonthButtonDisabled}
                right
                type="button"
            >
                <Icon source={LeftArrowIcon} height={14} width={14} />
            </DatePickerArrow>
        </DatePickerHead>
    );

    return (
        <InnerDatePicker
            disabled={disabled}
            selected={null}
            openToDate={start ?? undefined}
            renderCustomHeader={renderCustomHeader}
            onChange={handleChange}
            startDate={start ?? undefined}
            endDate={end ?? undefined}
            selectsRange
            shouldCloseOnSelect={false}
            showPopperArrow={false}
            locale={i18n.language}
            customInput={
                // <div>{`${startDate} - ${endDate}`}</div>
                <div>
                    <DatePickerInput
                        disabled={disabled}
                        type="text"
                        value={from || to ? `${from} - ${to}` : ''}
                        onChange={() => `${from} - ${to}`}
                        label={label}
                        placeholder={placeholder}
                    />
                </div>
            }
        />
    );
};
